import angular from 'angular';
import uiRouter from 'angular-ui-router';
import employeesComponent from './employees.component';
import dataTable from 'angular-material-data-table';

let employeesModule = angular.module('employees', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('employees', {
        url: '/employees',
        component: 'employees',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('employees', employeesComponent)
.name;

export default employeesModule;
